import { ChangeDetectionStrategy, Component } from "@angular/core";
import { navContent$ } from "src/app/nav-content/tryStartLoadingNavContent";
import { StandardLazyComponent } from "../../standard-lazy-component/standard-lazy-component.component";
import { StandardNavShellComponent } from "../../standard-nav-shell/standard-nav-shell.component";
import { MAX_SAFE_INTEGER } from "src/config";

@Component({
  standalone: true,
  selector: "app-logged-in-layout",
  templateUrl: "./logged-in-layout.component.html",
  imports: [StandardLazyComponent, StandardNavShellComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoggedInLayoutComponent {
  MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;

  readonly navContent$ = navContent$;
}
